import React, { useEffect, useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { AppSettings } from './../../config/app-settings.js';

function PosMenuStock() {
	const context = useContext(AppSettings);
	const [time] = useState(getTime());
	const [stockData, setStockData] = useState();

	function checkTime(i) {
		if (i < 10) {
			i = '0' + i;
		}
		return i;
	}

	function getTime() {
		var today = new Date();
		var h = today.getHours();
		var m = today.getMinutes();
		var a;
		m = checkTime(m);
		a = h > 11 ? 'pm' : 'am';
		h = h > 12 ? h - 12 : h;

		setTimeout(() => {
			getTime();
		}, 500);
		return h + ':' + m + a;
	}

	useEffect(() => {
		context.handleSetAppHeaderNone(true);
		context.handleSetAppSidebarNone(true);
		context.handleSetAppClass('app-without-header');
		context.handleSetAppContentFullHeight(true);
		context.handleSetAppContentClass('p-0');

		fetch('/color-admin/admin/react/assets/data/pos/menu-stock.json')
			.then((res) => res.json())
			.then((result) => {
				setStockData(result);
			});

		return () => {
			context.handleSetAppHeaderNone(false);
			context.handleSetAppSidebarNone(false);
			context.handleSetAppClass('');
			context.handleSetAppContentFullHeight(false);
			context.handleSetAppContentClass('');
		};

		// eslint-disable-next-line
	}, []);

	return (
		<div className="pos pos-with-header" id="pos">
			<div className="pos-header">
				<div className="logo">
					<Link to="/">
						<div className="logo-img">
							<Icon icon="solar:link-circle-line-duotone" />
						</div>
						<div className="logo-text">Pine & Dine</div>
					</Link>
				</div>
				<div className="time" id="time">
					{time}
				</div>
				<div className="nav">
					<div className="nav-item">
						<Link
							to="/pos/counter-checkout"
							className="nav-link"
							data-bs-toggle="tooltip"
							data-bs-placement="bottom"
							data-bs-title="Counter Checkout"
						>
							<Icon icon="solar:cart-3-bold-duotone" className="nav-icon" />
							<div className="nav-text">Counter</div>
						</Link>
					</div>
					<div className="nav-item">
						<Link
							to="/pos/kitchen-order"
							className="nav-link"
							data-bs-toggle="tooltip"
							data-bs-placement="bottom"
							data-bs-title="Kitchen Order"
						>
							<Icon icon="solar:documents-minimalistic-bold-duotone" className="nav-icon" />
							<div className="nav-text">Kitchen</div>
						</Link>
					</div>
					<div className="nav-item">
						<Link
							to="/pos/table-booking"
							className="nav-link"
							data-bs-toggle="tooltip"
							data-bs-placement="bottom"
							data-bs-title="Table Booking"
						>
							<Icon icon="solar:calendar-bold-duotone" className="nav-icon" />
							<div className="nav-text">Table</div>
						</Link>
					</div>
					<div className="nav-item">
						<Link
							to="/pos/menu-stock"
							className="nav-link active"
							data-bs-toggle="tooltip"
							data-bs-placement="bottom"
							data-bs-title="Menu Stock"
						>
							<Icon icon="solar:box-bold-duotone" className="nav-icon" />
							<div className="nav-text">Stock</div>
						</Link>
					</div>
				</div>
			</div>
			<div className="pos-content">
				<div className="pos-content-container p-4">
					<div className="pos-stock-product-row">
						{stockData && stockData.length > 0 ? (
							stockData.map((stock, index) => (
								<div className="pos-stock-product-col" key={stock.id}>
									<div className="pos-stock-product">
										<div className="pos-stock-product-container">
											<div className="product">
												<div className="product-img">
													<div
														className="img"
														style={{ backgroundImage: 'url(' + stock.image + ')' }}
													></div>
												</div>
												<div className="product-info">
													<div className="title">{stock.title}</div>
													<div className="desc">{stock.description}</div>
													<div className="product-option">
														<div className="option">
															<div className="option-label">Stock:</div>
															<div className="option-input">
																<input
																	type="text"
																	className="form-control w-60px"
																	defaultValue={stock.stock}
																/>
															</div>
														</div>
														<div className="option">
															<div className="option-label">Availability:</div>
															<div className="option-input">
																<div className="form-check form-switch">
																	<input
																		className="form-check-input"
																		type="checkbox"
																		name="qty"
																		id="product1"
																		defaultChecked={stock.available}
																		defaultValue="1"
																	/>
																	<label
																		className="form-check-label"
																		htmlFor="product1"
																	></label>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div className="product-action">
													<a href="#/" className="btn btn-default">
														<i className="fa fa-times fa-fw"></i> Cancel
													</a>
													<a href="#/" className="btn btn-success">
														<i className="fa fa-check fa-fw"></i> Update
													</a>
												</div>
											</div>
										</div>
									</div>
								</div>
							))
						) : (
							<div className="col-12">No records found</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
}

export default PosMenuStock;
